export default __webpack_public_path__ + "static/media/mentalHealth3.063a3dd0.jpeg";